import React, { useEffect, useRef, useState } from "react";
import { SERVICE } from "constants/global";
import { illust21 } from "assets/img";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { getInitChatBot } from "./chatbotSlice";
import { ButtonHome, ButtonClose, ButtonDown, ButtonBack } from "assets/svg";

const ChatBot = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathname = location.pathname;

  const [currentQuestion, setCurentQuestion] = useState(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [openChatBot, setOpenChatBot] = useState(null);
  const [listMessage, setListMessage] = useState([]);
  const chatBoxRef = useRef(null);
  const previousScrollTop = useRef(0);

  const { status, first_question, listQuestions } = useSelector(
    (state) => state.chatbot
  );

  // Initialize chat bot
  useEffect(() => {
    dispatch(getInitChatBot({ service: SERVICE, url: pathname }));
  }, []);

  // Initialize list of questions
  useEffect(() => {
    if (listQuestions && listQuestions.length > 0 || first_question) {
      handleQuestion(null, true);
    }
  }, [listQuestions]);

  // Scroll to bottom when new messages are added and open chatbot
  useEffect(() => {
    scrollToBottom();
  }, [listMessage, openChatBot]);

  // Handle scroll events to show or hide the scroll button
  useEffect(() => {
    const handleScroll = () => {
      if (chatBoxRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = chatBoxRef.current;
        if (scrollTop < scrollHeight - clientHeight - 50) {
          if (scrollTop < previousScrollTop.current) {
            setShowScrollButton(true);
          }
        } else {
          setShowScrollButton(false);
        }
        previousScrollTop.current = scrollTop;
      }
    };

    const chatBotElement = chatBoxRef.current;
    if (chatBotElement) {
      chatBotElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (chatBoxRef.current) {
        chatBoxRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [openChatBot]);

  // Scroll to the top 
  const scrollToTop = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTo(0, 0);
    }
  };

  // Scroll to the bottom
  const scrollToBottom = () => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTo(0, chatBoxRef.current.scrollHeight);
    }
  };

  // Add message to the list
  const addMessage = (type, parent_id, content, isInit = false) => {
    setListMessage((prevListMessage) => [
      ...prevListMessage,
      {
        type: type, // type = 1 (display question), type = 2 (display select question)
        init: isInit,
        parent_id: parent_id,
        message: isInit ? first_question : content,
        questions: getQuestions(parent_id),
      },
    ]);
    scrollToBottom();
  };

  // Get questions by parent ID
  const getQuestions = (parent_id) => {
    return listQuestions.filter((item) => item.parent_id == parent_id);
  };

  // Handle a question (show or go back)
  const handleQuestion = (question_id, isBack = false) => {
    const qa = listQuestions.find((item) => item.id == question_id);
    if (isBack && qa) {
      question_id = qa.parent_id;
    }

    if (question_id) {
      // add selection question
      if (!isBack) {
        addMessage(2, question_id, qa.question);
      }
      // check has list question
      const hasSubQuestions = getQuestions(question_id);
      const qaItem = isBack ? listQuestions.find((item) => item.id == question_id) : qa;
      addMessage(1, question_id, hasSubQuestions.length > 0 ? qaItem.question : (qaItem.answer ? qaItem.answer : '回答がありません。'));
    } else {
      // init list question
      addMessage(1, null, null, true);
    }

    setCurentQuestion(question_id);
  };

  // Go back to the previous question
  const backQuestion = () => {
    if (currentQuestion) {
      handleQuestion(currentQuestion, true);
    } else {
      handleQuestion(currentQuestion);
    }
  };

  return (
    <>
      {status && (
        <div className="chatbot--btn" onClick={() => setOpenChatBot(true)}>
          <img className="chatbot--img" src={illust21} alt={illust21} />
          <div>チャットで質問する</div>
        </div>
      )}
      {openChatBot && (
        <div className="chatbot--wrapper">
          <div className="chatbot--header">
            <div>チャットで質問する</div>
            <div className="group-btn">
              <div className="btn-icon">
                <ButtonBack onClick={() => backQuestion()} />
              </div>
              <div className="btn-icon">
                <ButtonHome onClick={() => scrollToTop()} />
              </div>
              <div className="btn-icon">
                <ButtonClose onClick={() => setOpenChatBot(false)} />
              </div>
            </div>
          </div>
          <div className="chatbot--body" ref={chatBoxRef}>
            {listMessage.map((message, index) =>
              message.type == 1 ? (
                <div
                  className="chat--item--wrapper answer"
                  key={`q` + index}
                  data-id={message.parent_id}
                >
                  <div className="chat--item--icon">
                    <img src={illust21} alt={illust21} />
                  </div>
                  <div
                    className={`chat--items--content ${message.init ? "first-question" : ""
                      }`}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: message?.message,
                      }}
                    ></div>
                    {message.questions.map((item, index) => (
                      <div
                        data-id={`lq-` + item.id + `-` + index}
                        key={`lq-` + item.id + `-` + index}
                        className="chat--item--content"
                        onClick={() => handleQuestion(item.id)}
                        dangerouslySetInnerHTML={{ __html: item?.question }}
                      ></div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="chat--item--wrapper ask" key={`a` + index}>
                  <div
                    className="chat--item--content"
                    dangerouslySetInnerHTML={{
                      __html: message?.message,
                    }}
                  ></div>
                </div>
              )
            )}
          </div>
          {showScrollButton && (
            <div className="scroll-button btn-icon" onClick={() => scrollToBottom()}>
              <ButtonDown />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ChatBot;
